
      var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 329,
  height: 329,
  viewBox: "0 0 101 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M47.021 32.639c0 15.277 13.89 19.097 20.834 19.097v31.248c0 1.737-24.306 6.945-31.25 6.945-5.556 0-9.26-2.315-10.417-3.472-1.157-4.63-4.492-16.233-6.945-26.042-3.472-13.889 10.417-12.153 17.362-12.153 0-4.629.347-14.582 1.736-17.36 5.208-5.208 6.944-3.472 8.68 1.737z",
  fill: "var(--theme-bright, #e3d2e9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.147 91.666H31.823c-4.683.002-8.71-3.339-9.603-7.966l-4.196-15.258c-3.734-10.661-2.109-16.333-.084-19.218a8.412 8.412 0 0 1 7.056-3.675h9.278a37.111 37.111 0 0 1 .387-11.566c2.257-9.082 7.197-9.48 9.21-9.23 3.15.391 6.02 3.153 6.02 5.796a17.57 17.57 0 0 0 4.62 13.02c4.7 4.73 13.182 5.997 13.266 6.01a2.356 2.356 0 0 1 1.989 2.668 2.346 2.346 0 0 1-2.65 2.001c-.412-.059-10.126-1.513-15.919-7.343a22.139 22.139 0 0 1-5.992-16.228 2.752 2.752 0 0 0-2.213-1.255c-1.497.061-2.912 2.194-3.784 5.706-1.195 4.81.026 12.318.038 12.393a2.369 2.369 0 0 1-.524 1.912 2.333 2.333 0 0 1-1.788.834H24.996a3.751 3.751 0 0 0-3.229 1.68c-.916 1.306-2.683 5.381.702 15 .018.052.034.105.05.158l4.244 15.431c.018.068.034.137.047.206a5.103 5.103 0 0 0 5.013 4.208h11.325c8.622 0 20.126-1.933 22.616-4.518a2.332 2.332 0 0 1 3.314-.053c.929.907.952 2.4.051 3.335-4.68 4.86-20.729 5.952-25.982 5.952z",
  fill: "var(--theme-primary, #810ea9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M82.885 91.355h-15.44a2.35 2.35 0 0 1-2.343-2.359V48.851a2.35 2.35 0 0 1 2.343-2.359h15.44a2.35 2.35 0 0 1 2.343 2.358v40.146a2.35 2.35 0 0 1-2.343 2.359z",
  fill: "var(--theme-primary, #810ea9)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M69.79 86.64h10.753V51.21H69.79v35.43zM42.784 19.717a2.35 2.35 0 0 1-2.343-2.358V10.69a2.35 2.35 0 0 1 2.343-2.358 2.35 2.35 0 0 1 2.343 2.358v6.669a2.35 2.35 0 0 1-2.343 2.358zm12.081 6.898a2.345 2.345 0 0 1-2.26-1.726 2.365 2.365 0 0 1 1.05-2.653l5.677-3.438a2.33 2.33 0 0 1 2.365-.07 2.36 2.36 0 0 1 1.22 2.04 2.361 2.361 0 0 1-1.169 2.07l-5.677 3.44a2.324 2.324 0 0 1-1.206.337zm-24.144.002c-.424 0-.841-.117-1.205-.338l-5.678-3.439a2.367 2.367 0 0 1-.768-3.217 2.334 2.334 0 0 1 3.184-.823l5.678 3.438a2.365 2.365 0 0 1 1.049 2.653 2.345 2.345 0 0 1-2.26 1.726z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"329\" height=\"329\" viewBox=\"0 0 101 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M47.021 32.639c0 15.277 13.89 19.097 20.834 19.097v31.248c0 1.737-24.306 6.945-31.25 6.945-5.556 0-9.26-2.315-10.417-3.472-1.157-4.63-4.492-16.233-6.945-26.042-3.472-13.889 10.417-12.153 17.362-12.153 0-4.629.347-14.582 1.736-17.36 5.208-5.208 6.944-3.472 8.68 1.737z\" fill=\"var(--theme-bright, #e3d2e9)\"/>\r\n    <path d=\"M43.147 91.666H31.823c-4.683.002-8.71-3.339-9.603-7.966l-4.196-15.258c-3.734-10.661-2.109-16.333-.084-19.218a8.412 8.412 0 0 1 7.056-3.675h9.278a37.111 37.111 0 0 1 .387-11.566c2.257-9.082 7.197-9.48 9.21-9.23 3.15.391 6.02 3.153 6.02 5.796a17.57 17.57 0 0 0 4.62 13.02c4.7 4.73 13.182 5.997 13.266 6.01a2.356 2.356 0 0 1 1.989 2.668 2.346 2.346 0 0 1-2.65 2.001c-.412-.059-10.126-1.513-15.919-7.343a22.139 22.139 0 0 1-5.992-16.228 2.752 2.752 0 0 0-2.213-1.255c-1.497.061-2.912 2.194-3.784 5.706-1.195 4.81.026 12.318.038 12.393a2.369 2.369 0 0 1-.524 1.912c-.445.53-1.099.834-1.788.834H24.996a3.751 3.751 0 0 0-3.229 1.68c-.916 1.306-2.683 5.381.702 15 .018.052.034.105.05.158l4.244 15.431c.018.068.034.137.047.206a5.103 5.103 0 0 0 5.013 4.208h11.325c8.622 0 20.126-1.933 22.616-4.518a2.332 2.332 0 0 1 3.314-.053c.929.907.952 2.4.051 3.335-4.68 4.86-20.729 5.952-25.982 5.952z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path d=\"M82.885 91.355h-15.44a2.35 2.35 0 0 1-2.343-2.359V48.851a2.35 2.35 0 0 1 2.343-2.359h15.44a2.35 2.35 0 0 1 2.343 2.358v40.146a2.35 2.35 0 0 1-2.343 2.359z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path d=\"M69.79 86.64h10.753V51.21H69.79v35.43zM42.784 19.717a2.35 2.35 0 0 1-2.343-2.358V10.69a2.35 2.35 0 0 1 2.343-2.358 2.35 2.35 0 0 1 2.343 2.358v6.669a2.35 2.35 0 0 1-2.343 2.358zM54.865 26.615a2.345 2.345 0 0 1-2.26-1.726 2.365 2.365 0 0 1 1.05-2.653l5.677-3.438a2.33 2.33 0 0 1 2.365-.07 2.36 2.36 0 0 1 1.22 2.04 2.361 2.361 0 0 1-1.169 2.07l-5.677 3.44a2.324 2.324 0 0 1-1.206.337zM30.721 26.617c-.424 0-.841-.117-1.205-.338l-5.678-3.439a2.367 2.367 0 0 1-.768-3.217 2.334 2.334 0 0 1 3.184-.823l5.678 3.438a2.365 2.365 0 0 1 1.049 2.653 2.345 2.345 0 0 1-2.26 1.726z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/like.c9bb59c06cec8ee4c91500c0fd502b26.svg"),
        {
          React: SvgLike,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      